import IncrementalButton from "../../../../components/incrementalButton";
import { useMainContext } from "../../../../context";
import { useItemPageContext } from "../../context";
import { useEffect } from "react";

const SelectRequirementsComponent = () => {
  const { product } = useMainContext();

  return (
    <section>
      {product.requireds.length > 0 && product.category.price_method === 1 ? (
        <SelectRequirementMethodPrice1 product={product} />
      ) : (
        <SelectRequirementMethodPrice2 product={product} />
      )}
    </section>
  );
};

const SelectRequirementMethodPrice1 = ({ product }) => {
  const { clickCheckRequired } = useItemPageContext();

  return (
    <>
      {product.requireds.map((required, indexRequired) => (
        <div
          key={required.id}
          className="border-2 border-gray-100 overflow-hidden rounded-md shadow"
        >
          <div className="bg-gray-100 p-4 flex items-center justify-between gap-2">
            <p className="text-lg font-bold">{required.name}</p>
            <div className="flex gap-2">
              <span className="text-sm rounded-full px-3 py-1 bg-secondary-500">
                Máx - {required.numChoose}
              </span>
              <span className="text-sm rounded-full px-3 py-1 bg-primary-200">
                Obrigatório
              </span>
            </div>
          </div>

          <div className="space-y-4 p-4">
            {required.groupsOptions.map((groupOption, indexGroup) => (
              <div key={groupOption.id} className="flex flex-col gap-1">
                <p className="font-bold text-md mb-1">{groupOption.name}</p>

                {groupOption.options.map((option, indexOption) => (
                  <label
                    key={option.id}
                    className={`cursor-pointer flex items-center px-4 py-3 rounded-lg hover:bg-gray-200 transition-colors ${option.status === "block" ? "opacity-50" : ""}`}
                  >
                    <input
                      onChange={() =>
                        option.status !== "block"
                          ? clickCheckRequired(
                              indexRequired,
                              indexGroup,
                              indexOption,
                            )
                          : {}
                      }
                      checked={option.selected}
                      type="checkbox"
                      disabled={option.status === "block"}
                      className="hidden peer"
                    />

                    <div className="w-5 h-5 mr-3 border-2 rounded border-gray-400 peer-checked:bg-primary-500 peer-checked:border-primary-500 flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="3"
                        viewBox="0 0 24 24"
                      >
                        <path d="M5 13l4 4L19 7" />
                      </svg>
                    </div>

                    <div className="flex-grow">
                      <div className="flex justify-between">
                        <p
                          className={`font-bold ${option.status === "block" ? "line-through" : ""}`}
                        >
                          {option.name}
                        </p>
                        {option?.price > 0 && (
                          <span className="text-primary-500 font-bold">
                            + R$ {option.price.toFixed(2).replace(".", ",")}
                          </span>
                        )}
                      </div>
                      <p className="text-gray-400 text-sm">
                        {option.description}
                      </p>
                    </div>
                  </label>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

const SelectRequirementMethodPrice2 = ({ product }) => {
  const {
    updateRequiredOptionQuantity,
    totalFlavorsSelected,
    getRequiredOptionsList,
  } = useItemPageContext();

  useEffect(() => {
    getRequiredOptionsList();
  }, []);

  return (
    <div className="border-2 border-gray-100 overflow-hidden rounded-md shadow">
      {product.requireds.map((required) => (
        <div key={required.id}>
          <div className="bg-gray-100 p-4 flex flex-wrap items-center justify-between gap-2">
            <p className="text-lg font-bold">{required.name}</p>
            <div className="flex flex-wrap gap-2">
              <span className="text-sm rounded-full px-3 py-1 bg-secondary-500">
                Escolhido: {totalFlavorsSelected} de {required.numChoose}{" "}
                frações
              </span>
              <span className="text-sm rounded-full px-3 py-1 bg-primary-200">
                Obrigatório
              </span>
            </div>
          </div>

          <div className="space-y-4 p-4">
            {required.groupsOptions.map((groupOption) => (
              <div key={groupOption.id}>
                <p className="font-bold text-md mb-1">{groupOption.name}</p>

                {groupOption.options.map((option) => (
                  <div
                    key={option.id}
                    className={`flex flex-col sm:flex-row gap-2 items-start justify-between px-4 py-3 rounded-lg ${option.status === "block" ? "opacity-50" : ""}`}
                  >
                    <div>
                      <div className="inline-flex gap-2">
                        <p
                          className={`font-bold ${option.status === "block" ? "line-through" : ""}`}
                        >
                          {option.name}
                          {option?.price > 0 && (
                            <span className="text-primary-500 font-bold ml-4 whitespace-nowrap break-keep">
                              + R$ {option.price.toFixed(2).replace(".", ",")}
                            </span>
                          )}
                        </p>
                      </div>
                      <p className="text-gray-400 text-sm">
                        {option.description}
                      </p>
                    </div>

                    <IncrementalButton
                      value={!option.quantity ? 0 : option.quantity}
                      onDecrease={() =>
                        updateRequiredOptionQuantity(option.id, false)
                      }
                      size="sm"
                      onIncrease={() =>
                        updateRequiredOptionQuantity(option.id, true)
                      }
                      min={0}
                    />
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectRequirementsComponent;
